// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionInput } from './ConditionInput';
import {
  ConditionInputFromJSON,
  ConditionInputFromJSONTyped,
  ConditionInputToJSON,
  ConditionInputToJSONTyped,
} from './ConditionInput';

/**
 *
 * @export
 * @interface PartitionStatusPatch
 */
export interface PartitionStatusPatch {
  /**
   *
   * @type {Array<ConditionInput>}
   * @memberof PartitionStatusPatch
   */
  conditions?: Array<ConditionInput>;
}

/**
 * Check if a given object implements the PartitionStatusPatch interface.
 */
export function instanceOfPartitionStatusPatch(
  value: object,
): value is PartitionStatusPatch {
  return true;
}

export function PartitionStatusPatchFromJSON(json: any): PartitionStatusPatch {
  return PartitionStatusPatchFromJSONTyped(json, false);
}

export function PartitionStatusPatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PartitionStatusPatch {
  if (json == null) {
    return json;
  }
  return {
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ConditionInputFromJSON),
  };
}

export function PartitionStatusPatchToJSON(json: any): PartitionStatusPatch {
  return PartitionStatusPatchToJSONTyped(json, false);
}

export function PartitionStatusPatchToJSONTyped(
  value?: PartitionStatusPatch | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ConditionInputToJSON),
  };
}
